import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div className="bg-white text-black">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 min-h-screen">
          {/* Left Column - Open Programs */}
          <div className="flex items-center p-8 md:p-12 lg:p-20 border-b lg:border-b-0 lg:border-r border-gray-200">
            <div>
              <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-6 sm:mb-8">
                Public Access
              </p>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-thin leading-tight mb-8 sm:mb-12">
                Open
                <br />
                <span className="text-gray-400">Programs</span>
              </h2>

              <div className="space-y-6 sm:space-y-8 text-sm sm:text-base md:text-lg font-light leading-relaxed mb-8 sm:mb-12">
                <p>
                  Join professionals from around the world in our carefully curated AI training programs. From
                  foundational concepts to advanced implementation strategies.
                </p>

                <p>
                  <span className="font-medium">Structured learning</span> designed for immediate application, delivered
                  by industry practitioners who understand the nuances of real-world AI deployment.
                </p>
              </div>
              <Link to="/programs">
                <button className="group border border-black px-10 sm:px-12 py-3.5 sm:py-4 text-[11px] sm:text-sm tracking-[0.2em] uppercase hover:bg-black hover:text-white transition-all duration-300">
                  <span className="group-hover:tracking-[0.3em] transition-all duration-300 flex items-center">
                    Explore Programs
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </span>
                </button>
              </Link>
            </div>
          </div>

          {/* Right Column - Custom Offerings */}
          <div className="flex items-center p-8 md:p-12 lg:p-20 bg-gray-50">
            <div>
              <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-6 sm:mb-8">
                Bespoke Solutions
              </p>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-thin leading-tight mb-8 sm:mb-12">
                Custom
                <br />
                <span className="text-gray-400">Offerings</span>
              </h2>

              <div className="space-y-6 sm:space-y-8 text-sm sm:text-base md:text-lg font-light leading-relaxed mb-8 sm:mb-12">
                <p>
                  Tailored AI implementation strategies that respect your organization&apos;s culture, compliance
                  requirements, and strategic objectives.
                </p>

                <p>
                  <span className="font-medium">Enterprise-grade solutions</span> with measurable ROI, from initial
                  assessment through full-scale deployment and governance.
                </p>
              </div>
              <Link to="/enterprise">
                <button className="border border-gray-400 px-10 sm:px-12 py-3.5 sm:py-4 text-[11px] sm:text-sm tracking-[0.2em] uppercase text-gray-600 hover:border-black hover:text-black transition-all duration-300">
                  <span className="hover:tracking-[0.3em] transition-all duration-300">
                    Partner With Us
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
